var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTime = function SvgTime(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    fillRule: "evenodd",
    d: "M8.5 8 3.836 4.89A3 3 0 0 1 2.5 2.395V2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v.394a3 3 0 0 1-1.336 2.497zm4.202-5.3a.9.9 0 0 1-.9.9H5.2a.9.9 0 0 1 0-1.8h6.602a.9.9 0 0 1 .9.9",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "m8.5 8 4.664 3.11a3 3 0 0 1 1.336 2.496V14a2 2 0 0 1-2 2h-8a2 2 0 0 1-2-2v-.394a3 3 0 0 1 1.336-2.497z"
  })));
};
export { SvgTime as ReactComponent };